<template>
  <div class="q-container-xxl q-col-md-6 q-offset-md-3 q-mt-3 q-mb-3">
    <div class="smartsearch-serp__input-group-container q-input-group q-input-group">
      <SearchInput :autocomplete="false"/>
    </div>
  </div>
</template>

<script setup lang="ts">
import SearchInput from '@/components/SearchOnlyInput.vue'




</script>

